module.exports = "/images/vendor/flag-icon-css/flags/1x1/tv.svg?a595f49d6d5586b06f4be66d5a8f7a15";